module.exports = __webpack_public_path__ + "img/date-of-application-status.7ceb4e67.svg";